var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.4 17.7",
    style: {
      enableBackground: "new 0 0 19.4 17.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    d: "M15.1,4.6c0-1.5,1.2-2.6,2.7-2.6s2.6,1.2,2.6,2.7c0,1.5-1.2,2.6-2.6,2.6C16.3,7.3,15.1,6.1,15.1,4.6 C15.1,4.7,15.1,4.6,15.1,4.6z M1.9,5.5h10.6c0.5,0,0.9-0.4,0.9-0.9S13,3.8,12.5,3.8l0,0H1.9C1.4,3.8,1,4.2,1,4.6S1.4,5.5,1.9,5.5z  M7.2,8.2c-1.1,0-2.1,0.7-2.5,1.8H1.9C1.4,9.9,1,10.3,1,10.8c0,0.5,0.4,0.9,0.9,0.9c0,0,0,0,0,0h2.8c0.5,1.4,2,2.1,3.4,1.6 c1.4-0.5,2.1-2,1.6-3.4C9.3,8.9,8.3,8.2,7.2,8.2L7.2,8.2z M19.5,9.9h-7.1c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h7.1 c0.5,0,0.9-0.4,0.9-0.9C20.4,10.3,20,9.9,19.5,9.9L19.5,9.9z M8.9,16.1H1.9C1.4,16.1,1,16.5,1,17c0,0.5,0.4,0.9,0.9,0.9h7.1 c0.5,0,0.9-0.4,0.9-0.9C9.8,16.5,9.4,16.1,8.9,16.1L8.9,16.1z M19.5,16.1h-2.8c-0.5-1.4-2-2.1-3.4-1.6c-1.4,0.5-2.1,2-1.6,3.4 s2,2.1,3.4,1.6c0.8-0.3,1.3-0.9,1.6-1.6h2.8c0.5,0,0.9-0.4,0.9-0.9C20.4,16.5,20,16.1,19.5,16.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.0a36bb5de5d766718d70d76e1abce33e.svg";
export { ForwardRef as ReactComponent };